import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_email = _resolveComponent("email")!
  const _component_auth_app = _resolveComponent("auth-app")!
  const _component_sms = _resolveComponent("sms")!
  const _component_other_device_approval = _resolveComponent("other-device-approval")!

  return (_ctx.result.mfa)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.result.mfa.type === 'email')
          ? (_openBlock(), _createBlock(_component_email, {
              key: 0,
              "session-id": _ctx.sessionId,
              result: _ctx.result,
              onResult: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('result', $event))),
              onError: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('error')))
            }, null, 8, ["session-id", "result"]))
          : _createCommentVNode("", true),
        (_ctx.result.mfa.type === 'auth_app')
          ? (_openBlock(), _createBlock(_component_auth_app, {
              key: 1,
              "session-id": _ctx.sessionId,
              result: _ctx.result,
              onResult: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('result', $event))),
              onError: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('error')))
            }, null, 8, ["session-id", "result"]))
          : (_ctx.result.mfa.type === 'sms')
            ? (_openBlock(), _createBlock(_component_sms, {
                key: 2,
                "session-id": _ctx.sessionId,
                result: _ctx.result,
                onResult: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('result', $event))),
                onError: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('error')))
              }, null, 8, ["session-id", "result"]))
            : (_ctx.result.mfa.type === 'other_device')
              ? (_openBlock(), _createBlock(_component_other_device_approval, {
                  key: 3,
                  "session-id": _ctx.sessionId,
                  result: _ctx.result,
                  onResult: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('result', $event)))
                }, null, 8, ["session-id", "result"]))
              : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}